interface Temporal {
    count: number;
    oldestAge: number;
}

export default class TemporalCountService {
    private readonly url: string;
    private readonly debug_id: string;
    private readonly key: string;
    private readonly timeToCount: number;
    private readonly tolerance: number;
    private firstTime = true;
    private readonly delay: number;

    public constructor(options: { url: string; debug_id: string; key: string; timeToCount: number; tolerance: number; delay: number }) {
        this.url = options.url;
        this.debug_id = options.debug_id;
        this.key = options.key;
        this.timeToCount = options.timeToCount;
        this.tolerance = options.tolerance;
        this.delay = options.delay;
    }

    public async isBot(): Promise<boolean> {
        if (!this.key) return false;

        if (!this.firstTime) return false;

        this.firstTime = false;

        // wait for other simultaneous bot clicks. bot usually perform several in a short interval
        await this.wait(this.delay * 1000);

        try {
            const response = await this.getTemporalCount(this.key);

            // too early or too many accesses to be a human
            if (response.oldestAge < 1 || response.count >= this.tolerance) {
                this.logBlockTemporalCount(this.key, 100);
                return true;
            }

            return false;
        } catch (error) {
            console.error('Not possible to get temporal count: ', error);
            return false;
        }
    }

    private async logBlockTemporalCount(key: string, score: number) {
        return fetch(`${this.url}block?id=${this.debug_id}&key=${key}&score=${score}`);
    }

    private async getTemporalCount(key: string): Promise<Temporal> {
        const response = await fetch(`${this.url}get?id=${this.debug_id}&key=${key}&sec=${this.timeToCount}`);
        return await response.json();
    }

    private wait(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}
